import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import {
  SalesListingDetailViewModel,
  SalesListingOverviewViewModel,
} from '@core/api';
import { ViewMode } from '../../../types/view-mode.types';

@Component({
  selector: 'app-sales-item',
  templateUrl: './sales-item.component.html',
  styleUrl: './sales-item.component.scss',
  standalone: false,
})
export class SalesItemComponent implements OnInit, OnChanges {
  @Input() items: SalesListingDetailViewModel[] = [];
  @Input() showPaginator: boolean = true;
  @Input() viewMode: ViewMode = 'list';
  @Input() pageIndex = 0;
  @Output() pageIndexChange = new EventEmitter<number>();
  @Output() selectedItem = new EventEmitter<SalesListingOverviewViewModel>();

  pageSize: number = 30;
  currentPage = 0;
  totalSize = 0;

  paginatedItems: SalesListingOverviewViewModel[] = [];

  ngOnInit() {
    this.currentPage = this.pageIndex;
    this.totalSize = this.items.length;
    this.updatePaginatedItems();
  }

  ngOnChanges() {
    this.totalSize = this.items.length;
    this.updatePaginatedItems();
  }

  @HostListener('window:resize')
  onResize() {
    this.updatePaginatedItems();
  }

  /**
   * Updates the paginated items based on the current page and page size.
   * Slices the items array to get the items for the current page.
   */
  updatePaginatedItems() {
    const startIndex = this.currentPage * this.pageSize;
    this.paginatedItems = this.items.slice(
      startIndex,
      startIndex + this.pageSize
    );
  }

  /**
   * Handles the page change event from the paginator.
   * Updates the page size and current page, then updates the paginated items.
   * @param event The page event containing the page index and page size.
   */
  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.pageIndexChange.emit(this.currentPage);
    this.updatePaginatedItems();
  }

  /**
   * Emits the selected item.
   * @param item The selected sale listing overview item.
   */
  selectItem(item: SalesListingOverviewViewModel) {
    this.selectedItem.emit(item);
  }
}
